import { ComponentType, ReactElement } from 'react';
import DraggableImpl, { DraggableProps } from 'react-draggable';

const Draggable = DraggableImpl as unknown as ComponentType<
  Partial<DraggableProps> & { children: ReactElement }
>;

export default Draggable;
